module.exports = __webpack_public_path__ + "static/media/iot-development01.f1f46ff5.jpg";